import {ChangeDetectionStrategy, Component} from '@angular/core';
import {CheckoutsSelectors} from '@store/checkouts/checkouts.selectors';
import {TableDefinition} from '@store/aviary/aviary.adapter';
import {Checkout} from '@store/checkouts/checkouts.types';
import {TableComponent} from '@aviary/components/table/table.component';
import {HiddenUntilLoadedDirective} from '@aviary/directives/hidden-until-loaded.directive';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {CHECKOUTS_TABLE_COLUMNS_DEFINITION, CHECKOUTS_TABLE_RESPONSIVE_DEFINITION} from '@app/my-account/checked-out/checked-out.constants';

@Component({
  selector: 'px-dependent-checked-out',
  template: `
    @let loaded = selectors.loaded | select:false;
    <div class="w-full px-0 md:px-6 py-5">
      <p class="text-headline-medium">Checked Out</p>
      <mx-table mxHiddenUntilLoaded [reveal]="loaded" [tableDefinition]="checkoutsTableDefinition"/>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TableComponent, HiddenUntilLoadedDirective, SelectPipe]
})
export class DependentCheckedOutComponent {
  public readonly selectors = CheckoutsSelectors.DependentCheckedOut;

  public readonly checkoutsTableDefinition: TableDefinition<Checkout, typeof CheckoutsSelectors.DependentCheckedOut> = {
    defaultSelectorContainer: CheckoutsSelectors.DependentCheckedOut,
    dataSource: 'checkouts',
    responsiveColumnsDefinition: CHECKOUTS_TABLE_RESPONSIVE_DEFINITION,
    columns: CHECKOUTS_TABLE_COLUMNS_DEFINITION
  };
}
